import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import Spacer, {
  ESpacerWeight,
} from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import signInSchemas from "@rentiohq/shared-frontend/dist/forms/signIn";
import * as signInActions from "@rentiohq/shared-frontend/dist/forms/signIn/schema.signIn.actions";
import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { createForm } from "@rentiohq/shared-frontend/dist/redux/form/form.actions";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import { IRootState } from "redux/reducers";
import FormMultistep from "../../../../components/FormMultistep";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";
import { getReferrer } from "../../../../utils/navigation.utils";
import * as S from "./SignIn.styles";

export const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [formId] = React.useState(generateFormId());
  const hasAccessToken = useSelector((state: IRootState) =>
    authSelectors.hasAccessToken(state),
  );
  const user = useSelector((state: IRootState) => authSelectors.getUser(state));

  const [preventRedirect, setPreventRedirect] = React.useState(false);

  // Lifecycle
  React.useEffect(() => {
    dispatch(
      createForm({
        formId,
        schemas: signInSchemas(
          process.env.NODE_ENV === "development"
            ? {
                phoneOrEmail: "dries@rentio.be",
                password: "test1234",
              }
            : {},
        ),
        withSummary: false,
      }),
    );
  }, []);

  // Event handlers
  const handleCustomSuccessAction = () => {
    setPreventRedirect(false);
  };

  const handlePressSignUp = () => {
    navigate("/auth/signup", {
      state: { referrer: getReferrer(location) },
    });
  };

  const handlePressForgotPassword = () => {
    navigate("/auth/forgot-password", {
      state: { referrer: getReferrer(location) },
    });
  };

  // Render
  const renderRedirect = () => {
    if (preventRedirect) {
      return null;
    }

    if (!hasAccessToken || !user) {
      return null;
    }

    return <Navigate to={getReferrer(location)} />;
  };

  const renderExtraTrailingControls = () => (
    <>
      <Spacer weight={ESpacerWeight.W16} />
      <S.ButtonInfo>
        <span>{getLocalizedText("auth.login.create_account.title")} </span>
        <ButtonBasic
          title={getLocalizedText("auth.login.create_account.cta")}
          onPress={handlePressSignUp}
        />
      </S.ButtonInfo>
      <Spacer weight={ESpacerWeight.W04} />
      <S.ButtonInfo>
        <span>{getLocalizedText("auth.login.forgot_password.title")} </span>
        <ButtonBasic
          title={getLocalizedText("auth.login.forgot_password.cta")}
          onPress={handlePressForgotPassword}
        />
      </S.ButtonInfo>
    </>
  );

  return (
    <>
      {renderRedirect()}
      <Page>
        <InfoHeader
          title={getLocalizedText("auth.login.title")}
          body={getLocalizedText("auth.login.body")}
        />
        <S.FormWrap>
          <FormMultistep
            formId={formId}
            // @ts-ignore state match
            isPerformingSubmitActionSelector={signInActions.isPerformingSubmitActionSelector()}
            // @ts-ignore state match
            performingSubmitActionResultSelector={signInActions.performingSubmitActionResultSelector()}
            // @ts-ignore state match
            performingSubmitActionErrorSelector={signInActions.performingSubmitActionErrorSelector()}
            submitActionCreator={signInActions.submitActionCreator()}
            customSuccessAction={handleCustomSuccessAction}
            renderExtraTrailingControls={renderExtraTrailingControls}
            submitTitle={getLocalizedText("auth.login.submit.label")}
          />
        </S.FormWrap>
      </Page>
    </>
  );
};
